import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { useShouldShowAuctaneNetworkBanner } from './use-should-show-auctane-network-banner';
import AuctaneFulfillmentNetworkLogo from './afn-logo-white.svg';
import messages from './auctane-network-banner-messages';
import styles from './auctane-network-banner.module.less';

const linkToAuctaneFulfillmentNetworkSite = '//auctane.com/fulfillment/?utm_source=shipstationapp&utm_medium=banner&utm_campaign=3pl';

export const AuctaneNetworkBanner = () => {
  const { formatMessage } = useIntl();

  const showBanner = useShouldShowAuctaneNetworkBanner();

  if (!showBanner) {
    return null;
  }

  return (
    <section className={styles['banner-container']}>
      <div className={styles['auctane-banner']}>
        <img
          alt={formatMessage(messages.bannerLogoAltText)}
          className={styles['auctane-banner__logo']}
          src={AuctaneFulfillmentNetworkLogo}
        />
      </div>
      <p className={styles['auctane-banner__description']}>
        <FormattedMessage {...messages.bannerText} />
      </p>
      <Button className={styles['auctane-banner__button']} href={linkToAuctaneFulfillmentNetworkSite} theme='primary'>
        <FormattedMessage {...messages.bannerButton} />
      </Button>
    </section>
  );
};
